module.exports = __webpack_public_path__ + "static/media/2x5B-empty-open.6c880c30.svg";